<ng-container *transloco="let t;">
<form (submit)="onSubmit()" novalidate *ngIf="exercise !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
            <button withRight="admin.exercise.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
            <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
            <p-menu #menu [popup]="true" [model]="items" role="menu"></p-menu>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
            <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="exercise.name"></app-form-control>
        <app-form-control [cid]="'title'" [control]="form.get('title')" [type]="'input'" [label]="t('common.labels.title_on_ac')" [edit]="inEdit" [basevalue]="exercise.title"></app-form-control>
        <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')" [edit]="inEdit" [basevalue]="t(exercise.getLanguageName())"></app-form-control>

        <div class="p-field-acr">
          <label>{{ t('common.labels.procedure_types') }}</label>
        </div>
        <div class="p-mb-2">
          <app-form-control [cid]="'for_single'" [control]="form.get('for_single')" [type]="'checkbox'" [label]="t('common.labels.for_single_procedures')" [edit]="inEdit" [basevalue]="exercise.forSingle()" [noMargin]="true"></app-form-control>
        </div>
        <app-form-control [cid]="'for_group'" [control]="form.get('for_group')" [type]="'checkbox'" [label]="t('common.labels.for_group_procedures')" [edit]="inEdit" [basevalue]="exercise.forGroup()" [noMargin]="true"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'description'" [control]="form.get('description')" [type]="'textarea'" [label]="t('common.labels.description')" [edit]="inEdit" [basevalue]="exercise.description"></app-form-control>
      </div>

    </div>

    <ng-container *ngIf="hasGroupSettings() === true">

      <hr/>

      <h2>{{ t('common.labels.settings_for_group_procedures') }}</h2>

      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'type'" [control]="form.get('group_settings.type')" [type]="'select'" [options]="types" [label]="t('common.labels.exercisetype')" [edit]="inEdit" [basevalue]="exercise.getTypeName()"></app-form-control>
          <app-form-control [cid]="'min_observers_per_candidate'" [control]="form.get('group_settings.min_observers_per_candidate')" [type]="'input'" [label]="t('common.labels.min_observer_per_candidate')" [edit]="inEdit" [basevalue]="exercise.group_settings?.min_observers_per_candidate"></app-form-control>
          <app-form-control *ngIf="isTeam()" [cid]="'min_candidates_per_team'" [control]="form.get('group_settings.min_candidates_per_team')" [type]="'input'" [label]="t('common.labels.min_candidates_per_team')" [edit]="inEdit" [basevalue]="exercise.group_settings?.min_candidates_per_team"></app-form-control>
          <app-form-control [cid]="'overlapping'" [control]="form.get('group_settings.overlapping')" [type]="'checkbox'" [label]="t('common.labels.exercise_overlapping')" [edit]="inEdit" [basevalue]="exercise.group_settings?.overlapping"></app-form-control>
        </div>
      </div>

    </ng-container>

</form>
</ng-container>
